import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type DeleteChatRequest = {
  chatId: string;
};

export type DeleteChatResponse = Chat;

export const deleteChat = async (body: DeleteChatRequest): Promise<DeleteChatResponse> => {
  const { data } = await axios.delete(`/chats/${body.chatId}/delete`);

  return data;
};
